module.exports = __webpack_public_path__ + "static/media/image.67720d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image.jpg
// module id = 78
// module chunks = 0